'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TableBody = require('./components/TableBody.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableBody).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/components/table-body/index.js
// module id = 1350
// module chunks = 1